
define(
	'Code25.CaterpartsGlobal.Shipping'
	, [
		"SC.Configuration", "Tools", "Code25.CaterpartsGlobal.AdditionalDelivery.Model", "Profile.Model", "Utils"
	]
	, function (
		Configuration, Tools, Model, ProfileModel, Utils
	) {
		'use strict';

		// before 12 delivery 69933

		return {
			mount: function mountToApp(container) {

				var OrderWizardModuleShipmethod = require('OrderWizard.Module.Shipmethod');

				if (OrderWizardModuleShipmethod) {

					_.extend(OrderWizardModuleShipmethod.prototype, {

						initialize: _.wrap(OrderWizardModuleShipmethod.prototype.initialize, function (initialize) {
							var res = initialize.apply(this, _.rest(arguments));
							// if (!Tools.isLive() || true) {
							var self = this;
							var model = new Model(), self = this;
							delete this.foundShipAddress;
							delete this.foundDelivery;
							model.fetch(
								{ data: {} }
							).done(function (result) {
								// console.log("done", result);
								// if(!Tools.isLive()){

								self.foundShipAddress = result.shipaddress;
								self.foundDelivery = result.shipaddress && result.foundDelivery;
								self.shipmethodname = (result.shipmethodname && result.shipmethodname.toLowerCase()) || "";

								// }
								self.render();

							}).catch(function (err) {
								console.error(err);

								// self.state = "error";
								// self.error = (err.message || err.responseText || err).toString();
								// self.render();
							});
							// }
							return res;
						}),
						submit: _.wrap(OrderWizardModuleShipmethod.prototype.submit, function (submit, options) {

							var custentity_c25_requirescalloutnumber = Tools.getProfileValue("custentity_c25_requirescalloutnumber");


							var custbody_cp_cs_call_out_no = document.getElementById("custbody_cp_cs_call_out_no");
							if (custentity_c25_requirescalloutnumber == "T" && custbody_cp_cs_call_out_no && !custbody_cp_cs_call_out_no.value) {
								Tools.showErrorInModal(this.options.wizard.application, Utils.translate('Callout #'), Utils.translate('Please enter a callout number.'));
								this.step.enableNavButtons();
								throw (new Error(Utils.translate('Please enter a callout number.')));
							} else {
								return submit.apply(this, _.rest(arguments));
							}

						}),
						getContext: _.wrap(OrderWizardModuleShipmethod.prototype.getContext, function (getContext) {

							var res = getContext.apply(this, _.rest(arguments));
							var matchDelivery = this.foundDelivery;
							if (this.foundShipAddress) {

								try {


									var profile = ProfileModel.getInstance();
									var addresses = profile.get("addresses"), address;
									for (var i = 0; i < addresses.models.length; i++) {
										if (this.model.get("shipaddress") == addresses.models[i].get("internalid")) {
											address = addresses.models[i];
											break;
										}
									}

									if (!address) {
										matchDelivery = false;
									} else if (this.foundShipAddress.address1.toLowerCase() != address.get("addr1").toLowerCase()) {
										matchDelivery = false;
									} else if (this.foundShipAddress.zip.toLowerCase() != address.get("zip").toLowerCase()) {
										matchDelivery = false;
									}

								} catch (err) {
									matchDelivery = false;
									//console.error(err);
								}
							}




							var pre12 = "next w'day pre 12.00";
							var standard = "standard delivery charge";
							var freepre12 = "free next w'day pre 12.00";
							var freestandard = "free standard delivery";
							var haspre12 = false, hasstandard = false;

							if (matchDelivery) {
								if (this.shipmethodname.indexOf(pre12) > -1 || this.shipmethodname.indexOf(freepre12) > -1) {
									haspre12 = true;
								} else {
									hasstandard = true;
								}
							}

							var name;
							var shipping_methods = res.shippingMethods;
							var custentity_c25_special_shipping = Tools.getProfileValue("custentity_c25_special_shipping") || "";
							custentity_c25_special_shipping = custentity_c25_special_shipping.split("\x05");
							var special = {};
							for (var j = 0; j < custentity_c25_special_shipping.length; j++) {
								special[custentity_c25_special_shipping[j]] = true;
							}
							
							for (var i = shipping_methods.length - 1; i >= 0; i--) {
								if (shipping_methods[i].name.indexOf("*") > -1) {
							
									if (!special[shipping_methods[i].internalid]) {
										shipping_methods.splice(i, 1);
									}else{
										shipping_methods[i].name=shipping_methods[i].name.split("*").join("");
									}
								}
							}


							var hasAdditional = false, isActive, countOptions = 0;
							for (var i = shipping_methods.length - 1; i >= 0; i--) {
								name = (shipping_methods[i].name && shipping_methods[i].name.toLowerCase()) || "";
								if (name.indexOf(freestandard) == 0 || name.indexOf(freepre12) == 0) {
									hasAdditional = true;
									countOptions++;
									if (shipping_methods[i].isActive) {
										isActive = true;
									}
								}
							}
							if (hasAdditional) {

								for (var i = shipping_methods.length - 1; i >= 0; i--) {
									name = (shipping_methods[i].name && shipping_methods[i].name.toLowerCase()) || "";
									//91141 standard

									if (matchDelivery) {
										if (name.indexOf(standard) == 0) {
											shipping_methods.splice(i, 1);
										}
										if (name.indexOf(pre12) == 0) {
											shipping_methods.splice(i, 1);
										}
										if (haspre12 && name.indexOf(freestandard) == 0 && countOptions > 1) {
											shipping_methods.splice(i, 1);
										}
										if (hasstandard && name.indexOf(freepre12) == 0) {
											shipping_methods.splice(i, 1);
										}
									} else {
										if (name.indexOf(freestandard) == 0) {
											shipping_methods.splice(i, 1);
										}
										if (name.indexOf(freepre12) == 0) {
											shipping_methods.splice(i, 1);
										}
										if (isActive && name.indexOf(standard) > -1 && hasstandard) { //Defaulted to free
											shipping_methods[i].isActive = true;
											this.model.set("shipmethod", shipping_methods[i].internalid);
										}
										if (isActive && name.indexOf(pre12) > -1 && haspre12) { //Defaulted to free 12
											shipping_methods[i].isActive = true;
											this.model.set("shipmethod", shipping_methods[i].internalid);
										}
									}

								}
							}
							res.shippingMethods = shipping_methods;
							//console.log(res);

							res.foundDelivery = matchDelivery && hasAdditional;
							var custentity_c25_requirescalloutnumber = Tools.getProfileValue("custentity_c25_requirescalloutnumber");


							res.custentity_c25_requirescalloutnumber = custentity_c25_requirescalloutnumber == "T";
							return res;

						})
					});
				}


				// var OrderWizardModuleShowShipments = require('OrderWizard.Module.ShowShipments');

				// _.extend(OrderWizardModuleShowShipments.prototype, {

				// 	getContext: _.wrap(OrderWizardModuleShowShipments.prototype.getContext, function (getContext, options) {

				// 		var res = getContext.apply(this, _.rest(arguments));

				// 		for (var i = 0; i < res.shippingMethods.length; i++) {

				// 			if (res.shippingMethods[i].rate_formatted === 'TBC*') {


				// 				if (res.shippingMethods[i].name == "Customer to Collect" || res.shippingMethods[i].name.toLowerCase().indexOf("free" > -1)) {
				// 					res.shippingMethods[i].rate_formatted = "Free";
				// 				} else {
				// 					res.shippingMethods[i].rate_formatted = "";
				// 				}

				// 			}

				// 		}

				// 		return res;

				// 	})
				// });



			}
		};
	});
